import { Result, ISingleTransactionRequest } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type Deposit = {
  id?: number;
  accountId?: number;
  narration?: string;
  amount?: number;
  accountNo?: string;
  accountName?: string;
  transactionId?: number;
  isReversed?: boolean;
  type?: number;
  slipNo?: string;
};

export class DepositService extends BaseService {
  private api: string = "deposits";
  private fixedDepositApi: string = "fixedDeposits";

  async getDeposits(params: {
    accountId?: number;
    fromDate?: Date;
    toDate?: Date;
    narration?: string;
    pageIndex: number;
    recordCount: number;
  }): Promise<Result<Deposit[]> | any> {
    const queryParams = this.ToQueryString(params);
    return this.get(`${this.api}${queryParams}`);
  }

  async getDeposit(id: number): Promise<Result<Deposit> | any> {
    return this.get(this.api + `/${id}`);
  }

  async bookOrUpdateDeposit(
    params: ISingleTransactionRequest,
    depositId?: number
  ): Promise<Result<Deposit | boolean>> {
    if (depositId) {
      return this.post(this.api, params);
    } else {
      return this.put(this.api + `/${depositId}`, params);
    }
  }

  async deleteDeposit(id: number): Promise<Result<boolean>> {
    return this.delete(this.api + `/${id}`);
  }

  async postTransaction(id: number): Promise<Result<number>> {
    return this.post(this.api + `/transaction/${id}`);
  }

  async reverseTransaction(
    id: number,
    reason: string = ""
  ): Promise<Result<number>> {
    return this.post(this.api + `/transaction/reverse/${id}`);
  }
}

export default new DepositService();
